import { Loader2 } from 'lucide-react'

/**
 * Active thread search in progress — spinner + message is intentional (process feedback,
 * not layout hydration). Do not replace with list skeletons unless showing dimmed
 * ThreadsListSkeleton behind this overlay.
 */
interface SearchLoadingStateProps {
  searchTerm: string
  debouncedSearchTerm: string
  isPreparing: boolean
  isSearching: boolean
  queryChanged: boolean
}

export function SearchLoadingState({
  searchTerm,
  debouncedSearchTerm,
  isPreparing,
  isSearching,
  queryChanged,
}: SearchLoadingStateProps) {
  // Determine which message to show based on priority
  let message = ''
  let displayTerm = ''
  let suffix = ''

  if (queryChanged && isPreparing) {
    // Highest priority: Query changed mid-search, now preparing
    message = 'New search terms detected, preparing to search'
    displayTerm = debouncedSearchTerm
    suffix = '...'
  } else if (queryChanged && isSearching) {
    // Query changed and now searching
    message = 'New search terms detected, now searching'
    displayTerm = debouncedSearchTerm
    suffix = ', one moment'
  } else if (isSearching) {
    // Active search in progress
    message = 'Now searching'
    displayTerm = debouncedSearchTerm
    suffix = ', one moment'
  } else if (isPreparing) {
    // Debouncing - user is typing
    message = 'Preparing to search'
    displayTerm = searchTerm
    suffix = '...'
  }

  if (!message) {
    return null
  }

  return (
    <div className="flex items-center justify-center h-64">
      <Loader2 className="h-8 w-8 animate-spin" />
      <span className="ml-2">
        {message}
        {displayTerm && (
          <span className="font-semibold"> "{displayTerm}"</span>
        )}
        {suffix}
      </span>
    </div>
  )
}

